import React, { useState, useEffect } from 'react';
import { http } from '../../lib/http';


const ActivityLogTab = ({ setMessage, setError, endpoint = '/admin/activity-logs', showActorFilter = false }) => {

    const [activities, setActivities] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        admin: 'all',
        actionType: 'all',
        actorType: 'all',
        dateFrom: '',
        dateTo: ''
    });

    const actorTypeOptions = [
        { value: 'all', label: 'All Users' },
        { value: 'customer', label: 'Customer' },
        { value: 'admin', label: 'Admin' },
        { value: 'owner', label: 'Owner' },
        { value: 'kitchen', label: 'Kitchen' },
        { value: 'driver', label: 'Driver' },
        { value: 'system', label: 'System' },
    ];

    const actionTypeOptions = [
        { value: 'all', label: 'All Actions' },
        // Customer actions
        { value: 'profile_update', label: 'Profile Update' },
        { value: 'preferences_saved', label: 'Preferences Saved' },
        { value: 'dietary_preferences_update', label: 'Dietary Preferences Update' },
        { value: 'meal_type_update', label: 'Meal Type Update' },
        { value: 'nv_days_update', label: 'NV Days Update' },
        { value: 'nv_meals_update', label: 'NV Meals Update' },
        { value: 'subscription_pause', label: 'Subscription Pause' },
        { value: 'subscription_unpause', label: 'Subscription Unpause' },
        { value: 'scheduled_pause_cancelled', label: 'Scheduled Pause Cancelled' },
        { value: 'renewal_response', label: 'Renewal Response' },
        { value: 'renewal_plan_change', label: 'Renewal Plan Change' },
        { value: 'addon_purchase', label: 'Add-on Purchase' },
        { value: 'addon_payment_verified', label: 'Add-on Payment Verified' },
        { value: 'feedback_submitted', label: 'Feedback Submitted' },
        { value: 'update_request_submitted', label: 'Update Request Submitted' },
        { value: 'workout_plan_created', label: 'Workout Plan Created' },
        { value: 'workout_plan_deleted', label: 'Workout Plan Deleted' },
        { value: 'workout_started', label: 'Workout Started' },
        { value: 'workout_marked_done', label: 'Workout Marked Done' },
        { value: 'workout_finished', label: 'Workout Finished' },
        { value: 'workout_session_deleted', label: 'Workout Session Deleted' },
        { value: 'reflection_saved', label: 'Reflection Saved' },
        { value: 'reflection_deleted', label: 'Reflection Deleted' },
        { value: 'todo_created', label: 'Todo Created' },
        { value: 'todo_completed', label: 'Todo Completed' },
        { value: 'todo_deleted', label: 'Todo Deleted' },
        { value: 'measurement_added', label: 'Measurement Added' },
        { value: 'measurement_deleted', label: 'Measurement Deleted' },
        { value: 'notification_read', label: 'Notification Read' },
        { value: 'notification_deleted', label: 'Notification Deleted' },
        // Admin actions
        { value: 'income_recorded', label: 'Income Recorded' },
        { value: 'income_deleted', label: 'Income Deleted' },
        { value: 'staff_created', label: 'Staff Created' },
        { value: 'staff_updated', label: 'Staff Updated' },
        { value: 'staff_password_reset', label: 'Staff Password Reset' },
        { value: 'staff_role_changed', label: 'Staff Role Changed' },
        { value: 'staff_revoked', label: 'Staff Revoked' },
        { value: 'staff_deleted', label: 'Staff Deleted' },
        { value: 'customer_renewed', label: 'Customer Renewed' },
        { value: 'preferences_set', label: 'Preferences Set' },
        { value: 'customer_activated', label: 'Customer Activated' },
        { value: 'payment_marked', label: 'Payment Marked' },
        { value: 'expense_category_created', label: 'Expense Category Created' },
        { value: 'expense_recorded', label: 'Expense Recorded' },
        { value: 'expense_deleted', label: 'Expense Deleted' },
        { value: 'message_sent', label: 'Message Sent' },
        { value: 'broadcast_sent', label: 'Broadcast Sent' },
        { value: 'broadcast_deleted', label: 'Broadcast Deleted' },
        { value: 'route_created', label: 'Route Created' },
        { value: 'route_deleted', label: 'Route Deleted' },
        { value: 'driver_assigned', label: 'Driver Assigned' },
        { value: 'driver_unassigned', label: 'Driver Unassigned' },
        { value: 'dispatch_updated', label: 'Dispatch Updated' },
        { value: 'dispatch_imported', label: 'Dispatch Imported' },
        { value: 'bulk_route_assigned', label: 'Bulk Route Assigned' },
        { value: 'weekly_menu_saved', label: 'Weekly Menu Saved' },
        { value: 'admin_notes_saved', label: 'Admin Notes Saved' },
        { value: 'chat_message_sent', label: 'Chat Message Sent' },
        { value: 'chats_cleared', label: 'Chats Cleared' },
        { value: 'chat_message_deleted', label: 'Chat Message Deleted' },
        { value: 'power_quote_set', label: 'Power Quote Set' },
        { value: 'update_request_deleted', label: 'Update Request Deleted' },
        { value: 'ex_client_deleted', label: 'Ex-Client Deleted' },
        { value: 'customers_csv_uploaded', label: 'Customers CSV Uploaded' },
        // Owner actions
        { value: 'customer_created', label: 'Customer Created' },
        { value: 'customer_edited', label: 'Customer Edited' },
        { value: 'customer_cancelled', label: 'Customer Cancelled' },
        { value: 'customer_paused', label: 'Customer Paused' },
        { value: 'customer_resumed', label: 'Customer Resumed' },
        { value: 'customer_deleted', label: 'Customer Deleted' },
        { value: 'user_created', label: 'User Created' },
        { value: 'user_updated', label: 'User Updated' },
        { value: 'password_changed', label: 'Password Changed' },
        { value: 'user_password_reset', label: 'User Password Reset' },
        { value: 'user_revoked', label: 'User Revoked' },
        { value: 'user_restored', label: 'User Restored' },
        { value: 'user_deleted', label: 'User Deleted' },
        { value: 'pricing_updated', label: 'Pricing Updated' },
        { value: 'personal_expense_added', label: 'Personal Expense Added' },
        { value: 'personal_expense_deleted', label: 'Personal Expense Deleted' },
        { value: 'expense_reason_added', label: 'Expense Reason Added' },
        { value: 'expense_reason_deleted', label: 'Expense Reason Deleted' },
        // Kitchen actions
        { value: 'shopping_list_created', label: 'Shopping List Created' },
        { value: 'shopping_item_toggled', label: 'Shopping Item Toggled' },
        { value: 'shopping_list_deleted', label: 'Shopping List Deleted' },
        // Driver actions
        { value: 'delivery_status_updated', label: 'Delivery Status Updated' },
        { value: 'delivery_confirmed', label: 'Delivery Confirmed' },
        // Staff actions
        { value: 'time_log_started', label: 'Time Log Started' },
        { value: 'time_log_stopped', label: 'Time Log Stopped' },
        // Payment
        { value: 'payment_completed', label: 'Payment Completed' },
    ];

    const loadActivityLog = async () => {
        setLoading(true);
        try {
            let url = `${endpoint}?`;
            if (filters.admin !== 'all') url += `admin_filter=${filters.admin}&`;
            if (filters.actionType !== 'all') url += `action_type_filter=${filters.actionType}&`;
            if (filters.actorType !== 'all') url += `actor_type_filter=${filters.actorType}&`;
            if (filters.dateFrom) url += `date_from=${filters.dateFrom}&`;
            if (filters.dateTo) url += `date_to=${filters.dateTo}&`;

            const response = await http.get(url);
            setActivities(response.data.activities || []);
            setAdmins(response.data.admins || []);
        } catch (error) {
            console.error('Failed to load activity log:', error);
            setError('Failed to load activity log');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadActivityLog();
    }, [filters]);

    const formatTimestamp = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const getActorTypeBadge = (actorType) => {
        const styles = {
            customer: 'bg-blue-100 text-blue-700 border-blue-300',
            admin: 'bg-purple-100 text-purple-700 border-purple-300',
            owner: 'bg-red-100 text-red-700 border-red-300',
            kitchen: 'bg-green-100 text-green-700 border-green-300',
            driver: 'bg-yellow-100 text-yellow-700 border-yellow-300',
            system: 'bg-gray-100 text-gray-700 border-gray-300',
        };
        return styles[actorType] || styles.system;
    };

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="bg-gradient-to-r from-black to-gray-900 rounded-xl p-6 border-2 border-orange-500">
                <div className="flex justify-between items-center">
                    <div>
                        <h2 className="text-3xl font-bold text-white mb-2">Activity Log</h2>
                        <p className="text-gray-300 text-sm">Track all actions and changes</p>
                    </div>
                    <button
                        onClick={loadActivityLog}
                        className="px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg hover:from-orange-600 hover:to-orange-700 font-semibold shadow-lg transition-all"
                    >
                        Refresh
                    </button>
                </div>
            </div>

            {/* Filters */}
            <div className="bg-white p-6 rounded-xl border-2 border-gray-200 shadow-md">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Filters</h3>
                <div className={`grid grid-cols-1 gap-4 ${showActorFilter ? 'md:grid-cols-5' : 'md:grid-cols-4'}`}>
                    {/* Actor Type Filter (Owner only) */}
                    {showActorFilter && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">User Type</label>
                            <select
                                value={filters.actorType}
                                onChange={(e) => setFilters({ ...filters, actorType: e.target.value })}
                                className="w-full bg-white text-gray-900 px-3 py-2 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                            >
                                {actorTypeOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* User Filter */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">User</label>
                        <select
                            value={filters.admin}
                            onChange={(e) => setFilters({ ...filters, admin: e.target.value })}
                            className="w-full bg-white text-gray-900 px-3 py-2 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        >
                            <option value="all">All Users</option>
                            {admins.map(admin => (
                                <option key={admin.admin_id} value={admin.admin_id}>
                                    {admin.admin_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Action Type Filter */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Action Type</label>
                        <select
                            value={filters.actionType}
                            onChange={(e) => setFilters({ ...filters, actionType: e.target.value })}
                            className="w-full bg-white text-gray-900 px-3 py-2 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        >
                            {actionTypeOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>

                    {/* Date From */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">From Date</label>
                        <input
                            type="date"
                            value={filters.dateFrom}
                            onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
                            className="w-full bg-white text-gray-900 px-3 py-2 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        />
                    </div>

                    {/* Date To */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">To Date</label>
                        <input
                            type="date"
                            value={filters.dateTo}
                            onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
                            className="w-full bg-white text-gray-900 px-3 py-2 rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        />
                    </div>
                </div>
            </div>

            {/* Activity List */}
            <div className="bg-white rounded-xl border-2 border-gray-200 shadow-lg overflow-hidden">
                {loading ? (
                    <div className="p-8 text-center text-gray-600">Loading activities...</div>
                ) : activities.length === 0 ? (
                    <div className="p-8 text-center text-gray-600">No activities found</div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gradient-to-r from-black to-gray-900">
                                <tr>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">Time</th>
                                    {showActorFilter && (
                                        <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">Type</th>
                                    )}
                                    <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">User</th>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">Action</th>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">Description</th>
                                    <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">Target</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {activities.map((activity) => (
                                    <tr key={activity.id} className="hover:bg-orange-50 transition-colors">
                                        <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap font-medium">
                                            {formatTimestamp(activity.timestamp)}
                                        </td>
                                        {showActorFilter && (
                                            <td className="px-4 py-3 text-sm">
                                                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold border ${getActorTypeBadge(activity.actor_type)}`}>
                                                    {(activity.actor_type || '').charAt(0).toUpperCase() + (activity.actor_type || '').slice(1)}
                                                </span>
                                            </td>
                                        )}
                                        <td className="px-4 py-3 text-sm text-gray-900 font-medium">
                                            {activity.admin_name}
                                        </td>
                                        <td className="px-4 py-3 text-sm">
                                            <span className="inline-flex items-center gap-2 px-3 py-1 bg-orange-100 rounded-lg text-orange-700 font-semibold border border-orange-300">
                                                {activity.action_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-700">
                                            {activity.action_description}
                                        </td>
                                        <td className="px-4 py-3 text-sm text-gray-500">
                                            {activity.customer_name || '-'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            <div className="text-sm text-gray-400 text-center">
                Showing {activities.length} activities
            </div>
        </div>
    );
};

export default ActivityLogTab;
